import React, { useEffect } from 'react'
import cssModules from 'react-css-modules'
import styles from './index.less'
import PropTypes from 'prop-types'
// eslint-disable-next-line import/no-unresolved
import { hydrate } from '@paypalcorp/globalnavsdk/client'

const Footer = ({ footerHtml }) => {
  useEffect(
    () => {
      if (footerHtml && window.__GLOBALNAV__?.footer) {
        hydrate('footer')
      }
    },
    [footerHtml]
  )

  return (
    <div
      data-testid="footer__container"
      dangerouslySetInnerHTML={{ __html: footerHtml }}
    />
  )
}

Footer.propTypes = {
  footerHtml: PropTypes.string.isRequired,
}

export default cssModules(Footer, styles)
